// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__1NGIo","page":"Pagination_page__1vJsU","dot":"Pagination_dot__100p2"};